<template>

  <div class="contact-panel h-100 overflow-auto bg-white">

    <!-- empty: no conversation selected -->
    <div
      v-if="!conversation && !loading"
      class="d-flex flex-column align-items-center justify-content-center h-100 text-center text-muted p-4">
      <i class="fa-regular fa-address-card fa-2x mb-2"></i>
      <p class="mb-0">{{ $t('No contact selected') }}</p>
    </div>

    <!-- loading skeleton -->
    <div
      v-else-if="loading && !conversation"
      class="p-3">
      <div class="skeleton skeleton-circle rounded-circle mx-auto mb-3"></div>
      <div class="skeleton w-50 mx-auto mb-3"></div>
      <div class="skeleton w-100 mb-3"></div>
      <div class="skeleton w-100"></div>
    </div>

    <!-- content -->
    <div
      v-else-if="conversation"
      class="contact-panel-content d-flex flex-column"
      :class="{ 'box-loading': saving }">

      <ContactHeader
        :conversation="conversation"
        :editing="editing"
        :saving="saving"
        :name="form.name"
        @update:name="form.name = $event"
        @edit="startEdit"
        @cancel="cancel"
        @save="save" />

      <!-- the channel and the address identify the contact, so they are fixed
      once the conversation exists: only the name can be edited here -->
      <div class="flex-grow-1 px-3">
        <ContactAddressField
          :type="conversation.type"
          :value="conversation.contact_address"
          :editing="false" />
        <ContactCandidateField
          :conversation="conversation"
          @updated="$emit('updated')" />
      </div>

    </div>

  </div>

</template>

<script>
import ContactHeader from './ContactHeader'
import ContactAddressField from './ContactAddressField'
import ContactCandidateField from './ContactCandidateField'

export default {
  name: 'ContactPanel',
  components: {
    ContactHeader,
    ContactAddressField,
    ContactCandidateField
  },
  props: {
    conversation: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editing: false,
      saving: false,
      form: {
        name: ''
      }
    }
  },
  watch: {
    conversation () {
      // leaving edit mode whenever the selected contact changes
      this.editing = false
      this.resetForm()
    }
  },
  methods: {
    /*
    resetForm
    copies the conversation fields into the local editable form
    */
    resetForm () {
      this.form = {
        name: this.conversation ? (this.conversation.name || '') : ''
      }
    },
    /*
    startEdit
    */
    startEdit () {
      this.resetForm()
      this.editing = true
    },
    /*
    cancel
    */
    cancel () {
      this.editing = false
      this.resetForm()
    },
    /*
    save
    */
    save () {
      this.saving = true

      const data = {
        name: this.form.name
      }

      this.$store
      .dispatch('updateConversation', { id: this.conversation._id, data: data })
      .then(() => {
        this.editing = false
        this.$store.dispatch('setWarn', { status: 'success' })
        this.$emit('updated')
      })
      .catch(() => {
        this.$store.dispatch('setWarn', { status: 'error' })
      })
      .finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style scoped>
/* fill the panel so the white background reaches the bottom */
.contact-panel-content {
  min-height: 100%;
}

/* pulsing grey placeholders shown while the contact loads */
.skeleton {
  height: 12px;
  background: #e9ecef;
  border-radius: 4px;
  animation: skeleton-pulse 1.4s ease-in-out infinite;
}

.skeleton-circle {
  width: 72px;
  height: 72px;
}

@keyframes skeleton-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactPanel.vue